import styles from './utility.module.scss';
import {CSSProperties} from 'react';
interface OwnProps {
    style?: CSSProperties;
}
export function Spacer({style}: OwnProps) {
    return <div style={style} className={styles.spacer} />;
}
